import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
    dsn: "https://f6f92e86d7d30af72e92461c7ebe659c@o4509627549417472.ingest.us.sentry.io/4510745455230976",
    integrations: [
      Sentry.browserTracingIntegration(), 
      // Sentry.replayIntegration()
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    enableLogs: true,
    sendDefaultPii: true
})

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));